import { ArrowRight } from "lucide-react";
import { HOME } from "@/constants/testIds";
import { Container, Eyebrow, GhostButton, PrimaryButton, scrollToId } from "./Primitives";
import IntelligenceField from "./IntelligenceField";
import AIToolsStrip from "./AIToolsStrip";

const LAYERS = ["Intelligent diagnosis", "Expert implementation", "Quality review"];

export default function Hero() {
  return (
    <section id="top" className="relative isolate overflow-hidden">
            <div aria-hidden className="fa-ambient fa-ambient--hero" />
      <IntelligenceField className="fa-field-mask" />
      <div aria-hidden className="fa-hero-veil" />
      <Container className="relative flex flex-col items-center pb-14 pt-24 text-center sm:pb-16 sm:pt-32 lg:pt-28">
        <Eyebrow className="fa-rise flex items-center gap-3">
          <span aria-hidden className="fa-beacon" /> Your Fractional AI Department.
        </Eyebrow>
        <h1 data-testid={HOME.heroHeadline}
          className="fa-rise mt-8 max-w-5xl font-display text-[2.7rem] font-light leading-[1.04] tracking-[-0.045em] text-fg sm:text-6xl lg:text-7xl xl:text-[5.75rem]"
          style={{ animationDelay: "90ms" }}>
          <span className="block">Whatever your business</span>
          <span className="block">needs from AI.</span>
          <span className="fa-lumen block pb-2">Done for you by AI Experts.</span>
        </h1>
        <p className="fa-rise mt-9 max-w-xl text-base font-light leading-relaxed text-subtle md:text-lg" style={{ animationDelay: "180ms" }}>
          Tell us what you want to improve, automate, build, or modernize. FreelancAI identifies where AI creates
          value and delivers the right solution through our internal AI experts and trusted AI partners.
        </p>
        <div className="fa-rise mt-11 flex w-full flex-col justify-center gap-3 sm:w-auto sm:flex-row" style={{ animationDelay: "260ms" }}>
          <PrimaryButton data-testid={HOME.heroStartCta} onClick={() => scrollToId("assessment")} className="fa-cta">
            Start Your AI Assessment <ArrowRight size={16} aria-hidden className="fa-arrow" />
          </PrimaryButton>
          <GhostButton data-testid={HOME.heroHowCta} onClick={() => scrollToId("how-it-works")}>
            See How It Works
          </GhostButton>
        </div>
        <div className="fa-rise mt-16 flex flex-col items-center gap-5" style={{ animationDelay: "340ms" }}>
          <p className="flex items-center gap-3 text-[13px] text-subtle">
            <span aria-hidden className="h-px w-8 bg-tone" />
            <span><span className="text-fg">AI-powered. Expert-built.</span> Delivered by internal AI experts and trusted AI partners under managed quality review.</span>
          </p>
          <ul aria-label="How every engagement is delivered" className="flex flex-wrap justify-center gap-x-6 gap-y-2 font-mono text-[10px] uppercase tracking-[0.2em] text-subtle/80">
            {LAYERS.map((l, i) => (
              <li key={l} className="flex items-center gap-2 whitespace-nowrap"><span className="text-tone">0{i + 1}</span>{l}</li>
            ))}
          </ul>
        </div>
      </Container>
      <AIToolsStrip />
    </section>
  );
}
